import { getChatApiBase, getChatApiHeaders } from '../chatApiClient'
import axios from '../axiosInstance'

export async function addPermssionRestrictions(id: string, post: any, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles/${id}/restrictedfeatures`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function listPermssionRestrictions(id: string, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles/${id}/restrictedfeatures`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function delPermssionRestrictions(id: string, post: any, app: any, apiHost: string) {
  const URL = `${getChatApiBase(app, apiHost)}/roles/${id}/restrictedfeatures`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
      data: {
        featuresToAllow: post.featuresToAllow,
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
